import * as iassign from "immutable-assign";

import { types } from "./types";

export type State = {
  name: string;
  stream: string;
  isLoggingIn: boolean;
  isLoggedIn: boolean;
  loggingInError: string;
};

const INITIAL_STATE: State = {
  name: null,
  stream: null,
  isLoggingIn: false,
  isLoggedIn: false,
  loggingInError: null
};

export function reducer(state: State = INITIAL_STATE, action: any): State {
  switch (action.type) {
    case types.LOGIN_ATTEMPT: {
      return iassign(
        state,
        s => {
          s.name = null;
          s.isLoggingIn = true;
          s.isLoggedIn = false;
          s.loggingInError = null;
          return s;
        }
      );
    }
    case types.LOGIN_SUCCESS: {
      return iassign(
        state,
        s => {
          s.name = action.payload.user.name;
          s.stream = action.payload.user.stream;
          s.isLoggingIn = false;
          s.isLoggedIn = true;
          s.loggingInError = null;
          return s;
        }
      );
    }
    case types.LOGIN_FAILURE: {
      return iassign(
        state,
        s => {
          s.name = null;
          s.isLoggingIn = false;
          s.isLoggedIn = false;
          s.loggingInError = action.payload.error.message;
          return s;
        }
      );
    }
    case types.LOGOUT_SUCCESS: {
      return iassign(
        state,
        s => {
          s.name = null;
          s.isLoggingIn = false;
          s.isLoggedIn = false;
          s.loggingInError = null;
          return s;
        }
      );
    }

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/reducer.ts